import type { Resolved } from '@nzyme/ioc/Injectable.js';
import { defineService } from '@nzyme/ioc/Service.js';
import { STRIPE_PUBLISHABLE_KEY } from '@sigma/stripe/stripeEnv.js';
import type { Stripe } from '@stripe/stripe-js';

export type StripeService = Resolved<typeof StripeService>;

export const StripeService = defineService({
    name: 'StripeService',
    deps: {
        publishableKey: STRIPE_PUBLISHABLE_KEY,
    },
    setup({ publishableKey }) {
        let stripePromise: Promise<Stripe | null> | null = null;

        return {
            getStripe,
        };

        function getStripe() {
            if (!stripePromise) {
                stripePromise = loadStripe();
            }

            return stripePromise;
        }

        async function loadStripe() {
            const { loadStripe: loadStripeSdk } = await import('@stripe/stripe-js');
            return await loadStripeSdk(publishableKey);
        }
    },
});
